IREP.survey = (function () {
    var focusGroupId;
    var init = function (initOptions) {
        focusGroupId = initOptions.focusGroupId;
    }

    $(".answer").on("click", function () {
        $(this).siblings().removeClass('selected');
        $(this).toggleClass('selected');
        return false;
    });

    var validateAnswers = function () {
        if ($(".selected").size() != 5) {
            $(".error").show();

            return false;
        } else {
            if ($("#questionSix").val() != "") {
                return true;
            }
            $(".error").show();
        }
        return false;
    }

    $("#submitButton").on("click", function () {
        if (validateAnswers()) {
            var results = [];
            $(".selected").each(function () {
                //console.log($(this).attr('data-questionId'),$(this).attr('id'), $(this));
                results.push({ questionId: $(this).attr('data-questionId'), answerId: $(this).attr('id') });
            });

            results.push({ questionId: $("#questionSix").attr('data-questionId'), answerId: $("#questionSix").attr('data-answerId'), text: $("#questionSix").val() });

            var data = {
                focusGroupId: focusGroupId,
                quizData: {
                    activityUID: $(this).attr('data-activityUID'),
                    results: results
                }
            };
            //console.log(data);
            IREP.callApi({ url: "/promotion/FocusGroup/Submit", data: data, type: "POST" }).done(function(data) {
                window.location.reload(true);
            });
            
        } 
        return false;
    });

    return {
        init: init
    };
})();